// crm-host.js — build-time CRM host substitution (Brief 188).
//
// Mirrors version.js's __KFE_VERSION__ pattern (Brief 140): build.mjs injects
// __CRM_HOST__ via esbuild's `define`, driven by the `--crm-host=<url>` build
// flag (default https://crm-staging.kungfuenglish.com — confirmed canonical
// test host, 2026-07-15). Unbundled dev (a static server with no esbuild
// step, Rule #6) sees the identifier as undeclared, so the same typeof guard
// falls back to the staging default there too.

export const CRM_HOST = (
  typeof __CRM_HOST__ !== "undefined" ? __CRM_HOST__ : "https://crm-staging.kungfuenglish.com"
);
